import React, { useContext } from 'react';
import store from '../../store';
import makestyles from '@material-ui/core/styles/makeStyles';
import { appheader } from '../../assets/jss';
const useStyles = makestyles((theme) => ({
    appheader: {
        ...appheader.large,
        [theme.breakpoints.down('sm')]: {
            ...appheader.small
        }
    }
}))

export default (props) => {
    const { profile } = useContext(store);
    const classes = useStyles();

    return (
        <header
            style={{ backgroundColor: profile.settings['Primary Background']}}
            className={classes.appheader}>
            {props.children}
        </header>
    )
}
